// Gemeinsame Filter von Liste und Karte (URL-Suchparameter). Höchstens 5 Filter: Status, Auftragsart,
// Gebiet, Sub, Frist-Ampel. Die Ampel gibt es serverseitig nicht und filtert im Client; die Volltextsuche
// `q` ist ein Suchfeld und kein Filter (zählt serverseitig als fünfter Parameter).
import { z } from 'zod'
import type { AreaGroupBy, OrderListParams, OrderStatus } from '@/api/queries'
import { AMPELN } from './ampel'

export const ORDER_STATUSES = [
  'NEW',
  'CLASSIFIED',
  'ASSIGNED',
  'ACCEPTED',
  'SCHEDULED',
  'IN_PROGRESS',
  'BLOCKED',
  'COMPLETION_REPORTED',
  'GC_APPROVED',
  'REPORTED_TO_CLIENT',
  'CLIENT_ACCEPTED',
  'BILLED',
  'CANCELLED',
] as const satisfies readonly OrderStatus[]

export const GROUP_BY = [
  'rajon',
  'municipality',
  'postal_code',
  'mdf',
] as const satisfies readonly AreaGroupBy[]

// TanStack Router parst URL-Werte als JSON: `?q=1001` kommt als Zahl an. Textfilter nehmen deshalb beides.
const text = z.union([z.string(), z.number()]).transform(String).optional().catch(undefined)

export const orderSearchSchema = z.object({
  status: z.enum(ORDER_STATUSES).optional().catch(undefined),
  orderType: text,
  groupBy: z.enum(GROUP_BY).optional().catch(undefined),
  area: text,
  assignedOrgId: text,
  ampel: z
    .enum(AMPELN as [string, ...string[]])
    .optional()
    .catch(undefined),
  q: text,
  // Karte: Ebene und Grubenfilter (D-20)
  layer: z.enum(['orders', 'pits']).optional().catch(undefined),
  pitState: z.enum(['offen', 'provisorisch', 'fertig']).optional().catch(undefined),
  pitDetail: z.enum(['asphalt_fehlt', 'pflaster_fehlt']).optional().catch(undefined),
})
export type OrderSearch = z.infer<typeof orderSearchSchema>

const AREA_PARAM: Record<AreaGroupBy, 'rajon' | 'municipality' | 'postalCode' | 'mdf'> = {
  rajon: 'rajon',
  municipality: 'municipality',
  postal_code: 'postalCode',
  mdf: 'mdf',
}

/** Serverparameter aus den Suchparametern (ohne Ampel, die filtert der Client). */
export function toListParams(search: OrderSearch): OrderListParams {
  const params: OrderListParams = {}
  if (search.status) params.status = search.status
  if (search.orderType) params.orderType = search.orderType
  if (search.assignedOrgId) params.assignedOrgId = search.assignedOrgId
  if (search.q) params.q = search.q
  if (search.area) params[AREA_PARAM[search.groupBy ?? 'rajon']] = search.area
  return params
}
